export const REGEX = {
  urlImage: /(http[s]?:\/\/.*\.(?:png|gif|webp|jpeg|jpg))/i,
  period: /^\d+(\.\d{0,2})?$/,
  url: /^(http[s]?):\/\/[^\s$.?#].[^\s]*$/
}
